import { createFileRoute } from '@tanstack/react-router'

import { SpamControlsPage } from '#/modules/communication/spam-controls-page'

export const Route = createFileRoute('/_shell/spam-controls')({
  component: SpamControlsPage,
})
